<template>
  <v-row>
    <v-col cols="12" sm="12" md="11" lg="11">
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>SN#</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.panelCodeSerialNumberFullName }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>Part#</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.panelCodePartNumber }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>Part Name</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.partName }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>Part Desc</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.partDesc }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>Mfr</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.mfr }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>UM</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.defaultUm }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>QTY</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.qty }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>Price</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ formatPrice(item.snapshotPriceIdr) }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>HO#</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.name }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "detail-ho-product",
  props: {
    item: Object,
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style></style>
